// @flow
import React, { Fragment } from 'react';
import classNames from 'classnames/bind';
// import split from 'ramda/es/split';
import isEmpty from 'ramda/es/isEmpty';
// import last from 'ramda/es/last';
import { Trans } from 'react-i18next';

import { TARIFF_CONSTRUCTOR, TARIFF_EXTERNAL_SYSTEM } from 'app/common/constants/tariffs';
// import toFixedValue from 'app/common/lib/toFixedValue';
import Note from 'app/components/Tariff/Note';
import PriceDiscounted, { priceTypes, PriceDiscountedConstruct } from 'app/components/Tariff/PriceDiscounted';
import isProduction from 'app/common/lib/isProduction';

import InformsStandartBranch from './InformsStandartBranch';
import InformsExtended from './InformsExtended';
import ButtonsStandart from './ButtonsStandart';
import ButtonsExtended from './ButtonsExtended';
import FootNote from './FootNote';
import enhanceTariff from './enhanceTariff';
import styles from './Tariff.scss';


const cx = classNames.bind(styles);
// Сборка цены для тарифа "Конструктор"
// TODO вынести в селектор
// const buildPrice = (informersMod, tariff) => {
//   const { lk_enabled: lkEnabled, mobile_enabled: mobileEnabled } = informersMod;
//   const { lk_cost: lkCost, mobile_cost: mobileCost } = tariff;
//   const lkPrice = lkEnabled ? parseFloat(lkCost) : 0;
//   const mobilePrice = mobileEnabled ? parseFloat(mobileCost) : 0;
//   const units = last(split(' ', lkCost || '')) || '';
//   return `${toFixedValue(lkPrice + mobilePrice)} ${units}`;
// };

type SmsBundle = {
  id: number,
  title: string,
  cost: string,
};

export type MonthDailyPeriod = {
  months_number: number,
  title: string,
  cost: string,
};

export type MonthDailyParams = {
  periods: Array<MonthDailyPeriod>,
  pause_after_period: boolean,
  money_return: boolean,
  sms_periods: Array<MonthDailyPeriod>,
  sms_subscribe_enabled: boolean,
};

export type TariffType = {
  key?: number,
  id: number,
  cost: string,
  kind: string,
  title: string,
  description: ?string,
  inside?: Array<TariffType>,
  // bundle_periods?: { // month_daily_params ???
  //   periods: Array<MonthDailyPeriod>,
  //   sms_periods: Array<MonthDailyPeriod>,
  // },
  sms_bundles?: Array<SmsBundle>,
  sms_limit?: number,
  sms_enabled?: boolean,
  sms_provided?: boolean,
  sms_cost?: string,
  lk_enabled?: boolean,
  lk_provided?: boolean,
  lk_cost?: string,
  mobile_enabled?: boolean,
  mobile_provided?: boolean,
  mobile_cost?: string,
  email_enabled?: boolean,
  email_provided?: boolean,
  email_cost?: string,
  month_daily_params?: MonthDailyParams,
  warn?: string,
  test_days_left?: number,
  activation_info?: string,
  tariff_ids?: Array<number>, // есть до композиции тарифов
}

export type Sub = {
  id: number,

  lk_paid: boolean,
  is_active: boolean,
  is_paused: boolean,
  sms_left: number,
  pay_ready: boolean,

  lk_paid: boolean,
  mobile_paid: boolean,
  sms_paid: boolean,
  email_paid: boolean,

  prepaid_start_at: ?string,
  prepaid_stop_at: ?string,

  sms_prepaid_start_at: ?string,
  sms_prepaid_stop_at: ?string,
  // tariff: TariffType,
  test_days_left?: number,
};

type Props = {
  studentId: number,
  subId?: string,
  sub: ?Sub,
  tariff: TariffType,
  footnotes: Object,
  footnotesKeys: Array<string>,
  stopping: boolean,
  pausingResuming: boolean,
  subscribing: boolean,
  saving: boolean,
  paying: boolean,

  handlePause: (e: SyntheticEvent<HTMLElement>) => void,
  handleStop: (e: SyntheticEvent<HTMLElement>) => void,
  handlePayToday: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubscribe: (e: SyntheticEvent<HTMLElement>) => void,
  handleInformerChange: (e: SyntheticEvent<HTMLElement>) => void,
  informersMod: Object,
  subscribeText: string,
  isInformersEditing: boolean,

  beginEditInformers: (void) => void,
  stopEditInformers: (void) => void,
  handleSaveInformers: (void) => void,
};

const Tariff = ({
  studentId,
  subId,
  sub,
  tariff,
  footnotes,
  footnotesKeys,
  stopping,
  pausingResuming,
  subscribing,
  saving,
  paying,

  handlePause,
  handleStop,
  handlePayToday,
  handleSubscribe,
  handleInformerChange,
  informersMod,
  subscribeText,
  isInformersEditing,
  beginEditInformers,
  stopEditInformers,
  handleSaveInformers,
}: Props) => {
  return (
    <div
      className={cx({
        root: true,
        paused: (sub && sub.is_paused),
        // stopped: (sub && !sub.lk_paid),
        clear: !sub,
      })}
    >
      <div className={styles.header}>
        <div className={styles.title}>
          <div>
            {tariff.title}
            {!isProduction()
              && subId
              && <span
                className={styles.debug}
              >
                &nbsp;&nbsp;&nbsp;id:&nbsp;
                {subId}
              </span>}
          </div>
          <div className={cx({ costExternalTitle: tariff.kind === TARIFF_EXTERNAL_SYSTEM })}>
            {tariff.kind === TARIFF_EXTERNAL_SYSTEM
              ? <Trans i18nKey="tariff:external_cost">
                {'Стоимость в соответствии с тарифом мобильной связи'}
              </Trans>
              : <Fragment>
                {/* <span className={styles.costInTitle}>
                  {tariff.cost}
                </span> */}
                <PriceDiscounted
                  className={styles.costInTitle}
                  studentId={studentId}
                  tariffId={!tariff.inside ? tariff.id : undefined}
                  tariffBundleId={tariff.inside ? tariff.id : undefined}
                  priceType={priceTypes.price_base}
                />
                <Note footnotes={footnotes} value="cost" />
              </Fragment>}
          </div>
        </div>

        <div className={styles.descriptionBlock}>
          {tariff.description instanceof Array
            ? <div>{tariff.description.map((a, i) => <div className={styles.info} key={i}>{a}</div>)}</div>
            : <div className={styles.info}>{tariff.description}</div>}
          {/* инфа о бесплатных днях в тарифе */}
          {!sub && tariff && !!tariff.test_days_left
            && <div className={styles.freeDays}>
              {sub ? sub.test_days_left : tariff.test_days_left}
              {' '}
              <Trans i18nKey="tariff:days_free">
                {'дней бесплатно'}
              </Trans>
            </div>}
        </div>
      </div>
      <div className={styles.line} />
      <div className={styles.content}>

        {/* Информеры */}
        <div className={styles.row}>
          {tariff.kind === TARIFF_CONSTRUCTOR
            ? <div>
              <InformsExtended
                studentId={studentId}
                sub={sub}
                subId={subId}
                tariff={tariff}
                informersMod={informersMod}
                footnotes={footnotes}
                onInformerChange={handleInformerChange}
                locked={!isInformersEditing}
                smsBundlesEnabled={tariff.sms_provided && tariff.sms_enabled}
                handlePayToday={handlePayToday}
                paying={paying}
              />
            </div>
            : <InformsStandartBranch
              studentId={studentId}
              sub={sub}
              tariff={tariff}
              subId={subId}
              footnotes={footnotes}
            />}
        </div>

        {/* Кнопки управления */}
        {tariff.kind !== TARIFF_EXTERNAL_SYSTEM
          && <Fragment>
            {tariff.kind === TARIFF_CONSTRUCTOR
              ? <div className={styles.costLine}>
                <div>
                  <div>
                    <Trans i18nKey="tariff:monthly">Ежемесячно</Trans>
                    <Note footnotes={footnotes} value="writeoff" />
                  </div>
                  <div className={styles.cost}>
                    {/* {buildPrice(informersMod, tariff)} */}
                    <PriceDiscountedConstruct
                      studentId={studentId}
                      tariffId={tariff.id}
                      informersState={informersMod}
                    />
                  </div>
                </div>
                <ButtonsExtended
                  sub={sub}
                  handlePayToday={handlePayToday}
                  handlePause={handlePause}
                  handleStop={handleStop}
                  handleSubscribe={handleSubscribe}

                  stopping={stopping}
                  subscribing={subscribing}
                  saving={saving}
                  operating={pausingResuming || stopping || subscribing || saving || paying}

                  footnotes={footnotes}
                  subscribeText={subscribeText}
                  beginEditInformers={beginEditInformers}
                  stopEditInformers={stopEditInformers}
                  handleSaveInformers={handleSaveInformers}
                  connectEnabled={
                    informersMod.lk_enabled
                    || informersMod.mobile_enabled
                    || informersMod.email_enabled
                    || informersMod.sms_enabled
                  }
                />
              </div>
              : <ButtonsStandart
                sub={sub}
                subId={subId}
                handlePayToday={handlePayToday}
                handlePause={handlePause}
                handleStop={handleStop}
                handleSubscribe={handleSubscribe}
                pausingResuming={pausingResuming}
                stopping={stopping}
                subscribing={subscribing}
                footnotes={footnotes}
                subscribeText={subscribeText}
                bundleWarn={tariff.warn}
              />}
            </Fragment>}
      </div>
      {!isEmpty(footnotesKeys)
        && <Fragment>
          <div className={styles.line} />
          <div className={styles.footer}>
            <FootNote
              notes={footnotes}
              keys={footnotesKeys}
              injectSMSCost={((footnotes.sms || footnotes.smspack)
                ? <PriceDiscounted
                  studentId={studentId}
                  tariffId={!tariff.inside ? tariff.id : undefined}
                  tariffBundleId={tariff.inside ? tariff.id : undefined}
                  priceType={priceTypes.price_sms}
                />
                : null
              )}
            />
          </div>
        </Fragment>}
    </div>
  );
};

export default enhanceTariff(Tariff);
